import { useMemo } from 'react';
import { emptyInitialParams, usePulseClient } from './shared';
import { useKey } from './useKey';
const emptyFn = () => {};
const fallbackActions = {
  getState: emptyFn,
  invalidate: emptyFn,
  invalidateAll: emptyFn,
  setState: emptyFn
};
export function useResourceActions(resource, options) {
  var _options$params;
  const client = usePulseClient();
  const params = (_options$params = options === null || options === void 0 ? void 0 : options.params) !== null && _options$params !== void 0 ? _options$params : emptyInitialParams;
  const instanceKey = useKey(resource, params);
  return useMemo(() => {
    const actions = client !== null && client !== void 0 ? client : fallbackActions;
    if (!resource) {
      return actions;
    }
    return {
      getState: () => actions.getState({
        resource,
        params,
        instanceKey
      }),
      setState: state => actions.setState({
        resource,
        params,
        instanceKey,
        state
      }),
      invalidate: () => actions.invalidate({
        resource,
        params,
        instanceKey
      }),
      invalidateAll: () => actions.invalidateAll({
        resource
      })
    };
    // instanceKey is a perfect proxy for params and resource changing
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [client, instanceKey]);
}